import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    marginBottom: 32,
    // height: 176,
    // width: "100%%",
  },
  tabs: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    // width: "100%",
  },
  tab: {
    "&.Mui-selected ": {
      backgroundColor: "#e3232a",
      color: "#fff",
    },
  },
}));

export default function HorizontalTabs({
  isId,
  valueTab,
  onChangeTab,
  listFasilitas,
}) {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Tabs
        variant="scrollable"
        value={valueTab}
        onChange={onChangeTab}
        aria-label="Vertical tabs example"
        className={classes.tabs}
      >
        {listFasilitas.map((row) => {
          return (
            <Tab
              key={row.title}
              className={classes.tab}
              label={isId ? row.title : row.title_en}
              {...a11yProps(row.id)}
            />
          );
        })}
      </Tabs>
    </div>
  );
}
